var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_54871_1219)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.7051,
    r: 17.5,
    fill: "#0071FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 32.5,
    fill: "#0071FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7731 53.9929C67.2914 53.4603 67.301 52.8586 67.2915 52.8586L67.2915 52.858C67.3205 52.618 67.3978 51.9784 65.1169 48.0913C64.6131 47.1467 64.9248 46.518 65.2882 45.7894C65.487 45.4002 65.6873 44.9969 65.731 44.5528C66.2494 39.3286 64.1494 36.4394 62.2611 34.5088C58.5847 30.7393 53.9857 30.0337 50.6693 30C42.8911 30.054 39.5585 32.5118 37.1139 35.1563C32.0665 40.6169 33.0719 45.454 33.0987 45.5214C33.2216 48.4051 36.8358 53.1077 37.2277 53.6088C39.9753 57.4371 38.7727 60.3101 38.7162 60.4418C38.5345 60.846 38.7226 61.3188 39.1402 61.4945C39.5498 61.6761 40.0432 61.4911 40.2297 61.087C40.2992 60.9337 41.8952 57.3057 38.5642 52.6662C37.5319 51.3455 34.8377 47.4788 34.735 45.3225C34.7003 45.1481 33.8959 41.0401 38.3437 36.2265C40.3856 34.0162 43.1905 31.6549 50.6821 31.6024H50.816C53.7384 31.6024 57.8432 32.308 61.0596 35.6088C62.7057 37.2945 64.5362 39.8197 64.0804 44.3975C64.0659 44.5547 63.9312 44.8248 63.801 45.0861L63.7992 45.0897C63.384 45.9191 62.759 47.1722 63.6637 48.8561C64.5715 50.4055 65.5859 52.3516 65.6504 52.6768C65.648 52.6969 65.6305 52.7385 65.6127 52.7806C65.593 52.8274 65.5729 52.8749 65.5729 52.8946C65.4358 53.0356 65.1172 53.1218 64.6133 53.1344C64.481 53.1486 64.1414 53.227 63.8684 53.5684C63.5907 53.9192 63.4923 54.4142 63.5697 54.9532L63.5957 56.1234C63.5488 56.153 63.4615 56.2047 63.3161 56.2502C63.1949 56.2881 63.0821 56.3536 62.9898 56.4478C62.6943 56.7408 62.5587 57.2764 62.9447 57.8449C62.9396 57.9169 62.8819 58.105 62.6232 58.4559L62.6222 58.4572C62.3264 58.8428 61.7802 59.555 62.1128 60.6942C62.2128 61.2174 62.1934 61.9143 62.1239 62.0353L62.115 62.0403C62.044 62.0803 62.0137 62.0974 61.9592 62.1636C61.9592 62.1636 61.9572 62.1648 61.9543 62.1668C61.8866 62.2138 61.1043 62.7573 58.5977 62.4661L58.1793 62.408L58.1677 62.4063C56.8885 62.2214 54.7617 61.9139 53.2813 63.7426C52.7733 64.6808 50.2194 69.4304 49.9811 70.793C49.9053 71.2288 50.2098 71.6422 50.6597 71.7173C50.7043 71.7235 50.7518 71.7265 50.7988 71.7265C51.1922 71.7265 51.5426 71.4508 51.6105 71.0593C51.7631 70.2008 53.6145 66.5728 54.6595 64.6149C55.4089 63.705 56.5868 63.794 57.9339 63.9913L58.3942 64.0541C61.4861 64.43 62.7009 63.6749 63.0741 63.3428C64.0772 62.6442 63.8366 60.9213 63.7218 60.3289C63.5914 59.8775 63.7178 59.7128 64.0259 59.3113L64.0287 59.3076C64.6409 58.4759 64.6571 57.8351 64.5521 57.431C65.1304 57.0299 65.2241 56.5304 65.2466 56.3266L65.219 54.8372C65.2108 54.7805 65.2061 54.7334 65.2045 54.6959C65.8716 54.6131 66.3966 54.3764 66.7731 53.9929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54871_1219",
    x: 0,
    y: 0.205078,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_54871_1219"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.559b4689b3d1cb2d79dc5e2fd24d2255.svg";
export { ForwardRef as ReactComponent };